import { graphql } from '../graphql/generated';

export const CHECK_PARAMETERS_QUERY = graphql(`
  query CheckParameters(
    $selectedParameters: [SelectedParameterInput!]!
    $patientData: PatientDataInput!
    $doctorId: ID!
  ) {
    checkParameters(selectedParameters: $selectedParameters, patientData: $patientData, doctorId: $doctorId) {
      selectedParameters {
        requestableParameter {
          id
          mainParameterId
          shortName
          longName
          withoutParameterIds
          acute
          volume
          billingInfos {
            billingType
            price
            text
            additionalText
            specialRateId
            diagnoseId
          }
          specimens {
            id
            classification
            name
            storagePeriod
            requiresLocalizations
            localizationInputEnabled
            predefinedLocalizations
            localizationFields {
              label
              inputType
              unit
              mandatory
            }
            testTubes {
              id
              color
              name
              hasImage
              labelText
              labelText2
              link
              volume
              specialPrinterRequired
            }
          }
          lab {
            id
            name
            shortName
            identifier
            aiEnabled
          }
          link
          description
          billingDescription
          importantDescription
          evalHours
          synonyms
          pricePatient
          withParameterNames
          withoutParameterNames
        }
        billingInfo {
          additionalText
          billingType
          diagnoseId
          text
          price
          specialRateId
        }
      }
      unknownBillingParameters {
        id
        shortName
        longName
      }
      unavailableParameters
    }
  }
`);
